(() => {
  if (customElements.get('tci-gallery-browser')) return;
  customElements.define('tci-gallery-browser', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.querySelector('.tci-gallery-filters').hidden = false;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter) this.filter(filter.dataset.filter);
        const photo = event.target.closest('[data-gallery-photo]');
        if (photo && typeof this.dialog.showModal === 'function') {
          event.preventDefault();
          this.opener = photo;
          this.querySelectorAll('video').forEach(video => video.pause());
          const image = document.createElement('img');
          image.alt = photo.querySelector('img')?.alt || 'Huse montate';
          image.src = photo.href;
          this.querySelector('[data-gallery-large]').replaceChildren(image);
          this.dialog.showModal();
          this.querySelector('[data-gallery-close]').focus();
        }
        if (event.target.closest('[data-gallery-close]')) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.querySelector('[data-gallery-large]').replaceChildren();
        this.opener?.focus();
      });
      this.addEventListener('shopify:block:select', () => this.filter('all'));
      this.filter('all');
    }
    disconnectedCallback() {
      this.querySelectorAll('video').forEach(video => video.pause());
      if (this.dialog?.open) this.dialog.close();
    }
    filter(kind) {
      let visible = 0;
      this.querySelectorAll('[data-gallery-kind]').forEach(card => {
        card.hidden = kind !== 'all' && card.dataset.galleryKind !== kind;
        if (card.hidden) card.querySelectorAll('video').forEach(video => video.pause());
        else visible++;
      });
      this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === kind)));
      this.querySelector('[data-gallery-empty]').hidden = visible !== 0;
      this.querySelector('.tci-gallery-count').textContent = `${visible} ${visible === 1 ? 'card afișat' : 'carduri afișate'}`;
    }
  });
})();
